export default "__VITE_PUBLIC_ASSET__48fe4203__"